import { QueryClient } from "@tanstack/react-query";

import { OrganisationsQuery } from "lib/generated/app-service-gql/graphql";

interface OpportunityRef {
  id: string;
}

type OrganisationWithOpportunities = {
  id: string;
  name: string;
  opportunities?: OpportunityRef[];
};

export function updateCachedOrganisations(
  queryClient: QueryClient,
  organisationId: string,
  updateOrganisation: (
    organisation: OrganisationWithOpportunities,
  ) => OrganisationWithOpportunities,
) {
  queryClient.setQueriesData<OrganisationsQuery>(["organisations"], (resp) => {
    if (!resp?.organisations) {
      return resp;
    }

    const organisations = [...resp.organisations];
    const orgIndex = organisations.findIndex((org) => org.id === organisationId);

    if (orgIndex === -1) {
      return resp;
    }

    organisations[orgIndex] = updateOrganisation(
      organisations[orgIndex] as OrganisationWithOpportunities,
    );

    return {
      ...resp,
      organisations,
    };
  });
}

export function updateCachedOrganisationOpportunities({
  queryClient,
  organisationId,
  opportunityId,
  isAdding,
}: {
  queryClient: QueryClient;
  organisationId: string;
  opportunityId: string;
  isAdding: boolean;
}) {
  updateCachedOrganisations(queryClient, organisationId, (organisation) => {
    const opportunities = organisation.opportunities || [];

    if (isAdding) {
      if (!opportunities.find((opp: OpportunityRef) => opp.id === opportunityId)) {
        return {
          ...organisation,
          opportunities: [...opportunities, { id: opportunityId }],
        };
      }
    }

    return {
      ...organisation,
      opportunities: isAdding
        ? opportunities
        : opportunities.filter((opp: OpportunityRef) => opp.id !== opportunityId),
    };
  });
}
